import { put } from 'redux-saga/effects';

import { getInDomain } from '../../../domains/externalUtils';

export function* closeRewardsCoachmark() {
  getInDomain('rewards.utils.closeCoachmark')();
  yield put(getInDomain('rewards.actions.clearOpenCoachmark'));
}
